import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginServicesService {
  constructor(private httpClient: HttpClient, private Config: Config) {}

  userLogin(loginData: any) {
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/login`,
        loginData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  resetPassword(email: any) {
    const body = email;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/resetPassword`,
        body
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  registerUser(registerData: any) {
    // console.log('registerData in service file', registerData);
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/register`,
        registerData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  resendEmailverifylink(email: any) {
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/resendEmailverifylink`,
        email
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllJiraProjects(authorizationData: any) {
   let  headersdata = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': authorizationData,
      'Access-Control-Allow-Origin': '*'
  })
    return this.httpClient
      .get(
        `https://dosmarttesting.atlassian.net/rest/api/2/project`,
        { headers: headersdata }
      
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllJiraStories(authorizationData: any) {
    let  headersdata = new HttpHeaders({
       'Content-Type':  'application/json',
       'Authorization': authorizationData,
       'Access-Control-Allow-Origin': '*'
   })
     return this.httpClient
       .get(
         `https://dosmarttesting.atlassian.net/rest/api/2/search?jql=project=dosmartQA&maxResults=50`,
         { headers: headersdata }
       )
       .pipe(
         map((response) => {
           return response;
         })
       );
   }

  // verifyEmailExpiryLink(verifylink: any) {
  //   const body = verifylink;
  //   return this.httpClient
  //     .post(
  //       `${environment.baseUrl}${environment.port}${environment.baseUri}/verifyEmaillink`,
  //       body
  //     )
  //     .pipe(
  //       map((response) => {
  //         return response;
  //       })
  //     );
  // }

  verifyEmailExpiryLink(loginData: any) {
    const body = loginData;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/verifyEmaillink`,
        body
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  emailVerification(verify: any) {
    const body = verify;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/verifyEmail`,
        body
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  acceptInvitation(verify: any) {
    const body = verify;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/addUserToInvitedOrg`,
        body
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateUserPassword(password: any) {
    const body = password;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updatePassword`,
        body
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
